module.exports = __webpack_public_path__ + "static/(072)OPA-918-98.4c6b7ce4.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/(072)OPA-918-98.jpg
// module id = 846
// module chunks = 155402202473113